import { styled } from '@mui/material/styles';

import { Theme, rem } from '../../theme';
import { Paragraph } from '../Paragraph';

export const StyledOuterWrapper = styled('div')`
    /* stylelint-disable unit-allowed-list */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing([rem(1.4), rem(3)], [6, 7.5])};
    background-color: ${({ theme }: { theme: Theme }) =>
        theme.palette.common.white};

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: ${({ theme }: { theme: Theme }) =>
            theme.tggSpacing([rem(2.1), rem(3)], [5.25, 7.5])};
    }
`;

export const StyledInnerWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        justify-content: space-between;
        margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};

        ${theme.breakpoints.up('desktop')} {
            gap: ${theme.tggSpacing(rem(2.4), 6)};
        }
	`}
`;

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-basis: 20%;
        justify-content: center;

        ${theme.breakpoints.up('desktop')} {
            flex: 1 0 auto;
            flex-basis: unset;
            align-items: center;
        }

        svg {
            min-width: ${theme.tggSpacing(rem(2.4), 6)};
            min-height: ${theme.tggSpacing(rem(2.4), 6)};
        }
	`}
`;

export const StyledParagraph = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) =>
        theme.typography.text_12_lh_14_desktop_14_lh_16}

    ${({ theme }: { theme: Theme }) => `
        padding-left: ${theme.tggSpacing(rem(0.3), 0.75)};

        ${theme.breakpoints.up(769)} {
            padding-left: ${theme.tggSpacing(rem(0.625), 1.5625)};
        }
	`}
`;
